import { ClipboardList, Sigma } from "lucide-react";
import { formatINR } from "@/lib/qgCalc";
import { STATUS_META, sectionCode } from "@/lib/qgApi";

function NavButton({ active, onClick, testId, children }) {
  return (
    <button type="button" onClick={onClick} data-testid={testId}
      className={`w-full text-left rounded-lg px-3 py-2 transition-colors border-l-4 ${active ? "bg-brillien-50 dark:bg-brillien-900/30 border-brillien-600" : "border-transparent hover:bg-slate-100 dark:hover:bg-slate-800"}`}>
      {children}
    </button>
  );
}

export function SectionNav({ q, calc, active, onSelect }) {
  const detailErrors = calc.errors.filter((e) => e.section_key === "details").length;
  const done = Object.values(calc.categories).filter((c) => c.status === "complete" || c.status === "not_applicable").length;
  return (
    <nav className="space-y-1" data-testid="qg-section-nav">
      <div className="px-3 pb-3">
        <div className="flex justify-between text-[11px] text-slate-500 mb-1"><span>Sections done</span><span data-testid="qg-progress-count">{done}/12</span></div>
        <div className="h-1.5 rounded-full bg-slate-200 dark:bg-slate-700 overflow-hidden"><div className="h-full bg-brillien-600 transition-[width] duration-500" style={{ width: `${(done / 12) * 100}%` }} /></div>
      </div>
      <NavButton active={active === "details"} onClick={() => onSelect("details")} testId="qg-nav-details">
        <span className="flex items-center gap-2 text-sm font-medium text-slate-800 dark:text-slate-100"><ClipboardList className="h-4 w-4 text-slate-400" />Project details</span>
        <span className={`text-[11px] ${detailErrors ? "text-amber-700" : "text-emerald-700"}`}>{detailErrors ? `${detailErrors} required field(s) missing` : "Complete"}</span>
      </NavButton>
      {["A", "B"].map((letter) => (
        <div key={letter} className="pt-3">
          <p className="px-3 pb-1 text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400">Section {letter}</p>
          {q.sections.filter((s) => s.section === letter).map((s) => {
            const c = calc.categories[s.key];
            const m = STATUS_META[c.status];
            return (
              <NavButton key={s.key} active={active === s.key} onClick={() => onSelect(s.key)} testId={`qg-nav-${s.key}`}>
                <span className="flex items-center gap-2">
                  <span className={`h-2 w-2 rounded-full shrink-0 ${m.dot}`} title={m.label} />
                  <span className="font-mono text-[11px] text-slate-400 w-6">{sectionCode(q.sections, s.key)}</span>
                  <span className="text-sm text-slate-800 dark:text-slate-100 truncate">{s.name}</span>
                </span>
                <span className="flex justify-between pl-10 text-[11px]">
                  <span className={m.text} data-testid={`qg-nav-status-${s.key}`}>{m.label}</span>
                  <span className="tabular-nums text-slate-500">{c.status === "not_applicable" ? "—" : formatINR(c.total)}</span>
                </span>
              </NavButton>
            );
          })}
        </div>
      ))}
      <div className="pt-3">
        <NavButton active={active === "summary"} onClick={() => onSelect("summary")} testId="qg-nav-summary">
          <span className="flex items-center gap-2 text-sm font-medium text-slate-800 dark:text-slate-100"><Sigma className="h-4 w-4 text-slate-400" />Summary &amp; generate</span>
          <span className="text-[11px] tabular-nums text-slate-600 dark:text-slate-300 font-semibold">{formatINR(calc.total, true)}</span>
        </NavButton>
      </div>
    </nav>
  );
}
